// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rows-loading {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.box {
    flex-grow: 1;
    border-radius: 6px;
}

.shine {
    background: #f6f7f8;
    background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
    background-repeat: no-repeat;
    background-size: 800px 104px;
    display: inline-block;
    position: relative;

    -webkit-animation-duration: 1s;
    -webkit-animation-fill-mode: forwards;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-name: placeholderShimmer;
    -webkit-animation-timing-function: linear;
}

@-webkit-keyframes placeholderShimmer {
    0% {
        background-position: -468px 0;
    }

    100% {
        background-position: 468px 0;
    }
}

`, "",{"version":3,"sources":["webpack://./wp_components/SkeletonRowLoader/skeleton-row-loader.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,+FAA+F;IAC/F,4BAA4B;IAC5B,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;;IAElB,8BAA8B;IAC9B,qCAAqC;IACrC,2CAA2C;IAC3C,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":[".rows-loading {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n.box {\r\n    flex-grow: 1;\r\n    border-radius: 6px;\r\n}\r\n\r\n.shine {\r\n    background: #f6f7f8;\r\n    background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);\r\n    background-repeat: no-repeat;\r\n    background-size: 800px 104px;\r\n    display: inline-block;\r\n    position: relative;\r\n\r\n    -webkit-animation-duration: 1s;\r\n    -webkit-animation-fill-mode: forwards;\r\n    -webkit-animation-iteration-count: infinite;\r\n    -webkit-animation-name: placeholderShimmer;\r\n    -webkit-animation-timing-function: linear;\r\n}\r\n\r\n@-webkit-keyframes placeholderShimmer {\r\n    0% {\r\n        background-position: -468px 0;\r\n    }\r\n\r\n    100% {\r\n        background-position: 468px 0;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
